var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007852",
    d: "M8.333.667A8.336 8.336 0 0 0 0 9c0 4.6 3.733 8.333 8.333 8.333S16.667 13.6 16.667 9 12.933.667 8.333.667ZM6.075 12.575 3.083 9.583a.83.83 0 1 1 1.175-1.175l2.409 2.4L12.4 5.075a.83.83 0 1 1 1.175 1.175L7.25 12.575a.83.83 0 0 1-1.175 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/Active.7853407b524e1d3f658c9b668131ad8c.svg";
export { ForwardRef as ReactComponent };